var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useState } from "react";
const OneClickLink = (_a) => {
    var { linkText, onClick, isLinkEnabled } = _a, props = __rest(_a, ["linkText", "onClick", "isLinkEnabled"]);
    const [disabled, setDisabled] = useState(props.disabled || false);
    useEffect(() => {
        if (isLinkEnabled) {
            setDisabled(true);
        }
    }, [isLinkEnabled, linkText, onClick]);
    return (React.createElement("button", Object.assign({}, props, { disabled: disabled, "aria-labelledby": "linkText", "aria-disabled": disabled, tabIndex: disabled ? -1 : 0, onClick: (e) => {
            if (disabled) {
                e.preventDefault(); // Prevent action if disabled
            }
            else {
                setDisabled(true);
                onClick();
            }
        }, style: {
            display: "inline-block", // Make it behave like a button
            background: "none", // Remove background
            border: "none", // Remove border
            textDecoration: "none", // Remove underline
            color: disabled ? "gray" : "blue", // Gray for disabled, blue for enabled
            cursor: disabled ? "not-allowed" : "pointer", // Pointer for enabled, not-allowed for disabled
            padding: "inherit", // Add padding to make it look like a button
            font: "'Open Sans', Arial, Helvetica, sans-serif !important", // Inherit font styles
            fontSize: "16px", // Inherit font size
            textAlign: "center", // Center-align text
            height: "auto !important",
        } }), linkText));
};
export default OneClickLink;
